import React from 'react';
import type {InputForm} from '@netx/core-components/Form';
import {LegacyFormCheckbox} from '@netx/core-components/Form/Checkbox';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormSubFieldName,
} from '../../utils';

export interface LegacyFormCustomFormItemCheckboxesProps {
	item: ICustomFormItem<'checkboxes'>;
	form: InputForm;
	value: Record<string, boolean>;
}

export const LegacyFormCustomFormItemCheckboxesPrimitive = ({
	item,
	form,
	value: _value,
}: LegacyFormCustomFormItemCheckboxesProps) => {
	const {disabled, value, required} = item;

	if (typeof value === 'string') return null;

	return (
		<>
			{value.map((val) => {
				const name = getCustomFormSubFieldName(item, val);

				return (
					<LegacyFormCheckbox
						key={name}
						value={_value[name]}
						disabled={
							disabled || typeof val === 'string' ? false : val.disabled
						}
						form={form}
						required={required}
						label={
							<span
								dangerouslySetInnerHTML={{
									__html:
										typeof val === 'string'
											? val
											: getCustomFormItemTranslatedLabel(val),
								}}
							/>
						}
						name={name}
					/>
				);
			})}
		</>
	);
};

export const LegacyFormCustomFormItemCheckboxes =
	LegacyFormCustomFormItemCheckboxesPrimitive;

export default LegacyFormCustomFormItemCheckboxes;
